import { combineReducers } from 'redux';
import { createBrowserHistory } from 'history';
import { createReduxHistoryContext } from 'redux-first-history';

import {
  activeAircraft,
  aircraftFilters,
  aircraftMap,
  aircraftList,
} from './aircraft';
import { currentTime, notificationSeenTime } from './time';
import { debug } from './debug';
import { activeFlight, flightMap, flightList } from './flight';
import { initialized } from './initialized';
import { user } from './user';
import { fleetHealth } from './fleet';
import { configuration } from './configuration';
import { top5LRUTypeCollection, top5LRUDetail } from './kiosk';

const { routerReducer } = createReduxHistoryContext({
  history: createBrowserHistory(),
});

const combinedReducers = () => {
  return combineReducers({
    activeAircraft,
    activeFlight,
    aircraftFilters,
    aircraftMap,
    aircraftList,
    configuration,
    currentTime,
    debug,
    fleetHealth,
    flightMap,
    flightList,
    router: routerReducer,
    initialized,
    user,
    top5LRUTypeCollection,
    top5LRUDetail,
    notificationSeenTime,
  });
};

export default combinedReducers;
